import React from "react";
import { NavLink } from "react-router-dom";
import './Pages/PagesCss/Footer.css';

const PRODUCTS = [
  { name: "Temp-MailHub",  url: "https://temp-mailhub.com",  status: "progress" },
  { name: "Talkified",     url: "https://talkified.com",     status: "prototype" },
  { name: "AfterTaxPay",   url: "https://aftertaxpay.net",   status: "live" },
  { name: "CreditsIQ",     url: "https://creditsiq.com",     status: "prototype" },
  { name: "CryptoMux",     url: "https://cryptomux.com",     status: "idea" },
  { name: "Font-Max",      url: "https://font-max.com",      status: "live" },
  { name: "QuickPDFs",     url: "https://quickpdfs.net",     status: "live" },
  { name: "AIPicks",       url: "https://aipicks.org",       status: "live" },
  { name: "NoobToBull",    url: "https://noobtobull.com",    status: "idea" },
  { name: "D-Tech Tools",  url: "https://tools.d-techstudios.com", status: "live" },
];

const STATUS_DOT = {
  live:      "#22c55e",
  progress:  "#3b82f6",
  prototype: "#f59e0b",
  idea:      "#8b5cf6",
};

const STATUS_DOTS = [
  { label: "Privacy Policy",     to: "/Legal/PrivacyPolicy" },
  { label: "Terms Of Service", to: "/Legal/TermsOfService" },
  { label: "Content Policy",    to: "/Legal/ContentPolicy" },
  { label: "Cookie Policy",  to: "/Legal/CookiePolicy" },
  { label: "Disclaimer",  to: "/Legal/Disclaimer" },
  { label: "Copyright Notice",  to: "/Legal/CopyrightNotice" },
];

const NAV_LINKS = [
  { label: "Home",     to: "/" },
  { label: "Products", to: "/Products" },
  { label: "Showcase", to: "/Showcase" },
  { label: "About",    to: "/About" },
  { label: "Contact",  to: "/Contact" },
  { label: "Founder",    to: "/FounderBio" },
];

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/people/D-Tech-Studios/61556107977536",
    icon: (
      <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.326v21.348C0 23.403.597 24 1.326 24h11.495v-9.294H9.691V11.01h3.13V8.41c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.464.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.31h3.587l-.467 3.696h-3.12V24h6.116C23.403 24 24 23.403 24 22.674V1.326C24 .597 23.403 0 22.675 0z" />
    </svg>
    ),
  },
  {
    label: "Twitter",
    href: "https://x.com/D_TechStudios",
    icon: (
      <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.59-6.64 7.59H.47l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zM17.61 20.644h2.04L6.486 3.24H4.298L17.61 20.644z" />
    </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile",
    icon: (
      <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.07c.67-1.27 2.3-2.6 4.73-2.6 5.06 0 6 3.33 6 7.66V24h-5V16.2c0-1.86-.04-4.26-2.6-4.26-2.6 0-3 2.03-3 4.12V24h-5V8z" />
    </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/d_techstudios/",
    icon: (
      <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.343 3.608 1.318.975.975 1.256 2.242 1.318 3.608.058 1.266.07 1.646.07 4.84s-.012 3.574-.07 4.84c-.062 1.366-.343 2.633-1.318 3.608-.975.975-2.242 1.256-3.608 1.318-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.343-3.608-1.318-.975-.975-1.256-2.242-1.318-3.608C2.175 15.574 2.163 15.194 2.163 12s.012-3.574.07-4.84c.062-1.366.343-2.633 1.318-3.608.975-.975 2.242-1.256 3.608-1.318 1.266-.058 1.646-.07 4.84-.07zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
    </svg>
    ),
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ft-root">

      {/* ══ TOP BAND ══ */}
      <div className="ft-top">
        <div className="ft-top-inner">
          <div className="ft-brand">
            <div className="ft-logo">
              <NavLink to="/" className="ft__logo" aria-label="D-TechStudios home">
                          <span className="ft__logo-text">D-Tech</span>
                          <span className="ft__logo-pill">
                            <span className="ft__logo-pill-text">Studios</span>
                          </span>
                        </NavLink>
            </div>
            <p className="ft-tagline">
              Building AI-powered tools that eliminate repetitive work,
              accelerate workflows, and give people back their most valuable
              asset time. Every product, built entirely in-house.
            </p>
            <div className="ft-socials">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ft-social-btn"
                  aria-label={s.label}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Navigation ── */}
          <div className="ft-col">
            <p className="ft-col-head">Studio</p>
            <ul className="ft-col-list">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    className={({ isActive }) =>
                      `ft-nav-link ${isActive ? "ft-nav-link--active" : ""}`
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Status legend ── */}
          <div className="ft-col">
            <p className="ft-col-head">Legal</p>
            <ul className="ft-col-list">
              {STATUS_DOTS.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    className={({ isActive }) =>
                      `ft-nav-link ${isActive ? "ft-nav-link--active" : ""}`
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Products ── */}
          <div className="ft-col ft-col--products">
            <p className="ft-col-head">Products</p>
            <ul className="ft-col-list ft-col-list--products">
              {PRODUCTS.map((p) => (
                <li key={p.name}>
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ft-prod-link"
                  >
                    <span
                      className="ft-prod-dot"
                      style={{ background: STATUS_DOT[p.status] }}
                    />
                    {p.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* ══ DIVIDER ══ */}
      <div className="ft-divider" />

      {/* ══ BOTTOM BAR ══ */}
      <div className="ft-bottom">
        <div className="ft-bottom-inner">
          <p className="ft-copy">
            &copy; {currentYear} D-Tech Studios. All rights reserved.
          </p>
          <div className="ft-bottom-links">
            <a href="/Legal/PrivacyPolicy" className="ft-bottom-link">Privacy Policy</a>
            <span className="ft-bottom-sep">·</span>
            <a href="/Legal/TermsOfService" className="ft-bottom-link">Terms of Use</a>
            <span className="ft-bottom-sep">·</span>
            <a href="/Legal/CookiePolicy" className="ft-bottom-link">Cookie Policy</a>
            <span className="ft-bottom-sep">·</span>
            <a href="/sitemap.xml" className="ft-bottom-link" target="_blank" rel="noopener noreferrer">Sitemap</a>
          </div>
          <p className="ft-built">
            Built entirely in-house &mdash; no outsourcing, ever.
          </p>
        </div>
      </div>

    </footer>
  );
}